import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import SelectionList, {
  CircularItem,
} from '@vfgroup-oneplatform/foundation/Components/SelectionList';
import VFText from '@vfgroup-oneplatform/foundation/Components/VFText';

import styles from './SetupAutoBill.Styles';

const createDays = count => {
  const days = [];
  for (let i = 0; i <= count - 1; i++) {
    if (i < 9) {
      days.push(`0${i + 1}`);
    } else {
      days.push(`${i + 1}`);
    }
  }
  return days;
};

const SetupAutoBill = ({ title, description, onItemSelect, selectedIndex, daysCount }) => {
  return (
    <View style={styles.containerStyle}>
      <SelectionList
        listStyle={styles.listStyle}
        title={title}
        options={createDays(daysCount)}
        customItem={<CircularItem />}
        itemWidth={49}
        withInitialScrollToIndex
        onSelectOption={(index, day, isActive) => onItemSelect(day)}
        initialSelectedIndex={selectedIndex}
        contentContainerStyle={styles.contentContainerStyle}
      />
      <VFText style={styles.description} i18nKey={description} />
    </View>
  );
};

SetupAutoBill.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onItemSelect: PropTypes.func,
  selectedIndex: PropTypes.number,
  daysCount: PropTypes.number,
};

export { createDays };
export default SetupAutoBill;
